module.exports = __webpack_public_path__ + "img/no_data.4dfa0007.svg";